import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 480);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <>
      {visible && (
        <button
          type="button"
          onClick={toTop}
          aria-label="返回顶部"
          className="fixed right-4 bottom-20 md:bottom-8 md:right-8 z-40 w-11 h-11 flex items-center justify-center rounded-full bg-accent-500 text-background-50 hover:bg-accent-600 transition-colors cursor-pointer animate-fade-in"
        >
          <i className="ri-arrow-up-line text-xl" />
        </button>
      )}

      {/* Mobile quick dock */}
      <div className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-background-100/95 backdrop-blur border-t border-background-200">
        <div className="grid grid-cols-4">
          {[
            { to: "/", icon: "ri-home-5-line", label: "首页" },
            { to: "/episodes", icon: "ri-film-line", label: "剧集" },
            { to: "/characters", icon: "ri-user-star-line", label: "角色" },
            { to: "/search", icon: "ri-search-line", label: "搜索" },
          ].map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className="flex flex-col items-center justify-center gap-1 py-2.5 text-foreground-500 active:text-accent-400 cursor-pointer"
            >
              <i className={`${item.icon} text-lg`} />
              <span className="text-[11px] font-label">{item.label}</span>
            </Link>
          ))}
        </div>
      </div>
    </>
  );
}